// extracted by mini-css-extract-plugin
module.exports = {"container":"mEPK","chatNow":"Kv7r","blogPostsContainer":"_3L4C"};